import styled from '@emotion/styled';

import NextIconGray from '@/assets/icons/icon_next_gray.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';
import { colorPaletteTheme } from '@/utility/theme/color';

export const Container = styled.div((props: { count: number }) =>
  mq({
    display: 'grid',
    width: '100%',
    height: ['600px', '600px', '489px', '489px'],
    padding: [
      `${defaultTheme.spacing.l} 0 ${defaultTheme.spacing.xs}`,
      `${defaultTheme.spacing.l} 0 ${defaultTheme.spacing.xs}`,
      `${defaultTheme.spacing.s} 0 20px`,
      `${defaultTheme.spacing.s} 0 20px`,
    ],
    '& > .swiper': {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: ['600px', '600px', '475px', '475px'],
      top: ['-10px', '-10px', '5px', '5px'],
      '& > .swiper-wrapper': {
        transform: '0',
      },
      '& > .swiper-pagination': {
        paddingLeft: '56px',
        paddingRight: '56px',
        paddingBottom: ['14px', '14px', '8px', '8px'],
      },
      '& > .swiper-pagination-bullets': {
        gridTemplateColumns: `repeat(${props.count}, minmax(10px, 48px))`,
        gridGap: [defaultTheme.spacing.xs, defaultTheme.spacing.s],
        justifyContent: 'center',
        position: 'initial',
        '.swiper-pagination-bullet': {
          opacity: 0.3,
          background: colorPaletteTheme.grayScale.dark,
        },
        '.swiper-pagination-bullet-active': {
          opacity: 1.0,
          background: colorPaletteTheme.grayScale.dark,
        },
      },
      '& > .swiper-slide': {
        left: '0px',
      },
    },
  }),
);

export const NavigationButton = styled.button(
  (props: { iconType: 'next' | 'prev'; slideWidth: string }) =>
    mq({
      position: 'absolute',
      top: [
        `calc(100% - ${defaultTheme.spacing.xl} - ${defaultTheme.spacing.xl})`,
        `calc(100% - ${defaultTheme.spacing.xl} - ${defaultTheme.spacing.xl})`,
        `calc(60% - ${defaultTheme.spacing.l} - ${defaultTheme.spacing.l})`,
        `calc(60% - ${defaultTheme.spacing.l} - ${defaultTheme.spacing.l})`,
      ],
      right: props.iconType === 'next' && [`12px`, `12px`, `24px`, `24px`],
      left: props.iconType === 'prev' && [`12px`, `12px`, `24px`, `24px`],
      width: '18.76px',
      height: '32px',
      backgroundImage: `url(${NextIconGray})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      zIndex: '100',
      transform: `rotate(${props.iconType === 'prev' ? '180deg' : '0deg'})`,
      ...hoverOpacity,
    }),
);

export const SlideWrapper = styled.div(() =>
  mq({
    paddingLeft: ['0px', '0px', '56px', '56px'],
    paddingRight: ['0px', '0px', '56px', '56px'],
    paddingBottom: ['8px', '8px', '0px', '0px'],
    width: '100%',
    height: '100%',
  }),
);
